import * as React from 'react';
import ouiStyle from '@goldwasserexchange/oui-style';
import { DomH2 } from '../../../HeadingSection';
export var SanityNewsH2 = function (props) {
    var children = props.children;
    return (React.createElement(DomH2, { lineFactor: 1.35, color: ouiStyle.Constants.Colors.accent, paddingTop: ['simple', undefined, undefined, 'simple', undefined, undefined], paddingBottom: ['simple', undefined, undefined, 'none', undefined, undefined] }, children));
};
